import { useDispatch } from "react-redux";

import {
  acknowledgeUpdate,
  clearOHDate,
  clearUnnecessaryOH,
  confirmAttendance,
  getMyOpenHouses,
  removeOH
} from "../../slices/openHousesSlice";

export const useOHBehavior = () => {
  const dispatch = useDispatch();

  return {
    clearUnnecessaryOHData: () => dispatch(clearUnnecessaryOH()),
    clearOHDate: () => dispatch(clearOHDate()),
    getOpenHouses: () => dispatch(getMyOpenHouses()),
    deregisterOH: ohId => dispatch(removeOH(ohId)),
    acknowledgeUpdateOH: (savedOHId, ohId) =>
      dispatch(acknowledgeUpdate({ savedOHId, ohId })),
    confirmOHAttendance: (savedOHId, attended, ohId) => {
      dispatch(confirmAttendance({ savedOHId, attended, ohId }));
    }
  };
};
